// extracted by mini-css-extract-plugin
export default {"page":"page_page__BZZNB","logo":"page_logo__jtOsH","title":"page_title__h7hQl"};